import { defineStore } from 'pinia';
import { getData } from '@/services/axios-service';
import { BASE_URL } from '@/utils/constants/api-constants';

const INITIAL_STATE = {};

export const useGroupStore = defineStore({
  id: 'groupStore',
  state: () => ({
    ...INITIAL_STATE,
  }),
  actions: {
    async getRelocatedGroup() {
      try {
        const { data, success, error } = await getData(`${BASE_URL.USERS}profile/organization`);

        if (success && data) {
          return data;
        } else {
          throw new Error(error);
        }
      } catch (error) {
        if (error instanceof Error) throw error;
        throw new Error(error?.toString() ?? 'Unknown error!');
      }
    },
  },
});

export type AuthStore = ReturnType<typeof useGroupStore>;
